import { useMemo } from 'react';

import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { isAuthenticated } from 'actions/user';
import Render from 'components/render';
import routes from 'constants/routes';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import { appDrawerSelector, appStatusSelector } from 'selectors/otherSelectors';
import { selectedProductState } from 'selectors/tradeSelectors';
import { useAppSelector } from 'storeHooks';

import {
  MarginModeSelectionDesktop,
  MarginModeSelectionMobile,
} from './MarginModeSelection';

const MARGIN_MODE_DROPDOWN_ENABLED_ROUTES = [
  'futures/trade',
  'options_chain/trade',
  'options/trade',
  'spot/trade',
  'move_options/trade',
  'options_combos/trade',
  'tracker/trade',
  routes.degradedManagePosition,
];

interface MarginModeWrapperProps {
  showFullHeader: boolean;
}

const MarginModeWrapper = ({ showFullHeader }: MarginModeWrapperProps) => {
  const { pathname } = useLocation();
  const isLoggedIn = useAppSelector(reduxState => isAuthenticated(reduxState?.user));
  const selectedProduct = useAppSelector(selectedProductState);
  const appStatus = useAppSelector(appStatusSelector);

  const { whenBelowMd } = useCustomMediaQuery();
  const { activeTab } = useSelector(appDrawerSelector);

  const isMarginModeDropdownEnabled = useMemo(() => {
    let enabled = MARGIN_MODE_DROPDOWN_ENABLED_ROUTES.some(route =>
      pathname.includes(route)
    );
    if (whenBelowMd && activeTab !== 'tabtrade') enabled = false;
    return enabled;
  }, [pathname, activeTab, whenBelowMd]);

  return (
    <Render
      when={
        isLoggedIn &&
        (selectedProduct || appStatus === 'degraded_mode') &&
        isMarginModeDropdownEnabled
      }
    >
      <Render when={whenBelowMd} else={<MarginModeSelectionDesktop />}>
        <MarginModeSelectionMobile showFullHeader={showFullHeader} />
      </Render>
    </Render>
  );
};

export default MarginModeWrapper;
